

































































import { Component, Vue, Prop } from 'vue-property-decorator';

import SelectField from '@/components/Form/SelectField.vue';
import TextField from '@/components/Form/TextField.vue';
import Checkbox from '@/components/Form/Checkbox.vue';

import Admin from '@/services/Admin';

@Component({
	name: 'UserInvite',
	components: {
		SelectField,
		TextField,
		Checkbox,
	},
})
export default class UserInvite extends Vue {
	@Prop() private user: any;
	@Prop() private roles: any;

	get get_roles() {
		return this.roles || [];
	}

	private roleChanged($event) {
		this.roles.forEach(role => {
			if (role.role_id === $event.target.value) {
				this.user.permissions = role.permissions;
			}
		});
	}
}
